
import React from 'react';
import { useDispatch } from 'react-redux';

import projectGetActions from '../../sagas/project';

import DialogEditOperationItem from './DialogEditOperationItem';
import OperationItemList from './OperationItemList.state';
import OperationView from './Operation.view';

const Operation = ({
    col,
    expanded,
    onCollapseClick,
    onExpandClick,
    operation,
    pricelistData,
    readOnly
}) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const handleAddClick = async () => {
        let result = await DialogEditOperationItem.show(
            operation, '', 0.0
        );
        if (result) {
            projectActions.addOperationItem(
                operation.id, result.title, result.price
            )
        }
    }

    const handleCollapseClick = () => {
        if (onCollapseClick) {
            onCollapseClick(operation);
        }
    }

    const handleExpandClick = () => {
        if (onExpandClick) {
            onExpandClick(operation);
        }
    }

    const getToolbarItems = () => {
        let items = [];

        if (expanded) {
            items.push({onClick: handleCollapseClick, title: 'Sbalit'});
        } else {
            items.push({onClick: handleExpandClick, title: 'Rozbalit'});
        }
        if (!readOnly) {
            items.push({onClick: handleAddClick, title: 'Přidat'});
        }

        return items;
    }

    const operationItems = (pricelistData.items || []).filter(
        item => item.opId === operation.id
    );

    const renderOperationItems = () => {
        return (
            <OperationItemList
                operation={operation}
                operationItems={operationItems}
                readOnly={readOnly}
            />
        );
    }

    return (
        <OperationView
            col={col}
            expanded={expanded}
            operation={operation}
            operationItems={operationItems}
            operationItemList={renderOperationItems()}
            readOnly={readOnly}
            toolbarItems={getToolbarItems()}
        />
    );
}

export default Operation;
